import { createContext, useContext } from 'react';
import { BarChartState } from './types';

export const BarChartContext = createContext<BarChartState | null>(null);

export function useBarChartContext() {
  const context = useContext(BarChartContext);
  if (!context) {
    throw new Error('useBarChartContext must be used within a BarChart');
  }
  return context;
}
